import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {
  map,
  catchError,
  takeUntil,
} from 'rxjs/operators';
import { Subject, of } from 'rxjs';
import { UsersService } from 'app/services/users-service/users.service';

@Injectable()
export class HasCompanyGuardService implements OnDestroy {

  private onDestroy$ = new Subject<void>();

  constructor(
    private readonly userService: UsersService
  ) {}

  canActivate() {
    // this function needs to
    return this.userService.user$
    .pipe(
      map(user => {
        // 1) check if user has a companyAccountId assigned to their user
        if (user.companyId || user.id.startsWith('waad') || user.id.startsWith('oidc|Allegion-OIDC')) {
        // 2) if so, go to /company route (return true)
          return true;
        }
        return false;
      }),
      catchError(error => of(false)),
      takeUntil(this.onDestroy$)
    );

  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
